import { render, staticRenderFns } from "./ClickIcon.vue?vue&type=template&id=6e9d38ed&scoped=true&"
import script from "./ClickIcon.vue?vue&type=script&lang=js&"
export * from "./ClickIcon.vue?vue&type=script&lang=js&"
import style0 from "./ClickIcon.vue?vue&type=style&index=0&id=6e9d38ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9d38ed",
  null
  
)

export default component.exports